import { render } from "./towndistricts.vue?vue&type=template&id=16c2ebd0"
import script from "./towndistricts.vue?vue&type=script&lang=js"
export * from "./towndistricts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__